<template>
  <div class="admin-layout">
    <aside class="sidebar">
      <div class="sidebar-brand" @click="$router.push('/admin/dashboard')">后台管理</div>
      <nav class="sidebar-nav">
        <router-link to="/admin/dashboard" class="nav-item">
          <span class="nav-icon">📊</span> 数据概览
        </router-link>
        <router-link to="/admin/cards" class="nav-item">
          <span class="nav-icon">💳</span> 卡密管理
        </router-link>
        <router-link to="/admin/chat" class="nav-item">
          <span class="nav-icon">💬</span> 在线客服
        </router-link>
        <router-link to="/admin/assets" class="nav-item">
          <span class="nav-icon">🖼️</span> 页面素材
        </router-link>
        <router-link to="/admin/settings" class="nav-item">
          <span class="nav-icon">⚙️</span> 账号设置
        </router-link>
      </nav>
      <div class="sidebar-footer">
        <button class="logout-btn" @click="logout">退出登录</button>
      </div>
    </aside>
    <main class="main-content">
      <div class="site-bar">
        <span class="site-bar-label">当前管理版本</span>
        <div class="site-tabs">
          <button
            v-for="s in siteOptions"
            :key="s.value"
            type="button"
            class="site-tab"
            :class="{ active: activeSite === s.value, zhongqiu: s.value === 'zhongqiu' }"
            @click="switchSite(s.value)"
          >{{ s.label }}</button>
        </div>
        <span class="site-bar-current">正在管理：{{ activeSiteLabel }}</span>
      </div>
      <router-view :key="siteViewKey" />
    </main>
  </div>
</template>

<script>
import { SITE_OPTIONS, getAdminSite, setAdminSite, siteLabel } from '@/utils/site';

export default {
  name: 'AdminLayout',
  data() {
    return {
      siteOptions: SITE_OPTIONS,
      activeSite: getAdminSite()
    };
  },
  computed: {
    siteViewKey() {
      return this.activeSite + '-' + this.$route.path;
    },
    activeSiteLabel() {
      return siteLabel(this.activeSite);
    }
  },
  methods: {
    switchSite(site) {
      this.activeSite = site;
      setAdminSite(site);
    },
    logout() {
      sessionStorage.removeItem('adminToken');
      this.$router.replace('/admin/login');
    }
  }
};
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
}
.sidebar {
  width: 220px;
  background: #1a1a2e;
  color: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.sidebar-brand {
  padding: 20px 18px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  cursor: pointer;
}
.sidebar-nav {
  flex: 1;
  padding: 12px 0;
}
.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  font-size: 15px;
  transition: all 0.15s;
}
.nav-item:hover {
  color: #fff;
  background: rgba(255,255,255,0.06);
}
.nav-item.router-link-exact-active {
  color: #27ae60;
  background: rgba(39,174,96,0.1);
  border-right: 3px solid #27ae60;
}
.nav-icon {
  font-size: 18px;
}
.sidebar-footer {
  padding: 14px 18px;
  border-top: 1px solid rgba(255,255,255,0.08);
}
.logout-btn {
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 8px;
  color: rgba(255,255,255,0.7);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}
.logout-btn:hover {
  border-color: #e74c3c;
  color: #e74c3c;
}
.main-content {
  flex: 1;
  background: #f4f6f9;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.site-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
}
.site-bar-label {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}
.site-tabs {
  display: flex;
  gap: 8px;
}
.site-tab {
  padding: 6px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
}
.site-tab.active {
  background: #27ae60;
  color: #fff;
  border-color: #27ae60;
}
.site-tab.active.zhongqiu {
  background: #c0392b;
  border-color: #c0392b;
}
.site-bar-current {
  margin-left: auto;
  font-size: 13px;
  color: #888;
}

@media (max-width: 768px) {
  .sidebar {
    width: 180px;
  }
}
</style>
